module.exports = __webpack_public_path__ + "img/logo.d6329e27.svg";